// extracted by mini-css-extract-plugin
export var summarySectionContent = "order-summary-section-module--summary-section-content--d5rfr";
export var titleText = "order-summary-section-module--title-text--xOBRG";